const _temp0 = require("../../../../public/images/pipes/BR.svg");
const _temp1 = require("../../../../public/images/pipes/Down.svg");
const _temp2 = require("../../../../public/images/pipes/LB.svg");
const _temp3 = require("../../../../public/images/pipes/LocalStorage.svg");
const _temp4 = require("../../../../public/images/pipes/Lock.svg");
const _temp5 = require("../../../../public/images/pipes/LR.svg");
const _temp6 = require("../../../../public/images/pipes/LT.svg");
const _temp7 = require("../../../../public/images/pipes/Outflow.svg");
const _temp8 = require("../../../../public/images/pipes/TB.svg");
const _temp9 = require("../../../../public/images/pipes/TR.svg");
const _temp10 = require("../../../../public/images/pipes/TransferStation.svg");
const _temp11 = require("../../../../public/images/pipes/Up.svg");
module.exports = {
  "BR": _temp0,
  "Down": _temp1,
  "LB": _temp2,
  "LocalStorage": _temp3,
  "Lock": _temp4,
  "LR": _temp5,
  "LT": _temp6,
  "Outflow": _temp7,
  "TB": _temp8,
  "TR": _temp9,
  "TransferStation": _temp10,
  "Up": _temp11
}